import { COMPANY_DNS, COMPANY_ID } from 'config/company.constants'

const NEXYS_DNS = 'nexys.com'

const RESERVED_BROKER_SLUGS = ['www', 'api', 'staging', 'mail', 'reply', 'images', 'mcp', 'nexys', 'nextres']

export type HostWhiteLabelBrand = {
  logoUrl: string
  footer: Record<string, any>
}

/**
 * One-label vanity host slug (`{slug}.nexys.com`), excluding tenant primary and reserved labels.
 */
export const getBrokerHostSlug = (hostname = typeof window !== 'undefined' ? window.location.hostname : ''): string | null => {
  if (!hostname) return null
  const host = String(hostname).trim().toLowerCase().split(':')[0]

  const roots = [NEXYS_DNS, COMPANY_DNS].filter(Boolean).map((d) => String(d).toLowerCase())
  const uniqueRoots = [...new Set(roots)]

  for (const root of uniqueRoots) {
    const suffix = `.${root}`
    if (!host.endsWith(suffix)) continue
    const label = host.slice(0, -suffix.length)
    if (!label || label.includes('.')) continue
    if (!/^[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?$/.test(label)) continue
    if (RESERVED_BROKER_SLUGS.includes(label)) return null
    if (COMPANY_ID && label === String(COMPANY_ID).toLowerCase()) return null
    return label
  }
  return null
}
